import { defineComponent } from 'vue';
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

export default defineComponent({
  name: 'LineChartComponent',
  components: { Line },
  props: {
    chartData: {
      type: Object
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
  },
  setup: () => {
    const chartOptions = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value: number) => { if (value % 1 === 0) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); } }
          }
        }
      }
    };

    return {
      chartOptions,
    };
  }
});
